<template>
  <div class="compute" v-if="locale.compute">

    <template v-if="loadingState">
      <div class="spinner">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 200 117" style="enable-background:new 0 0 200 117;" xml:space="preserve">
            <g id="triangle8">
                <path class="st0" d="M153,60.4l-22,10.9l22-31.4V60.4z"/>
            </g>
            <g id="triangle7">
                <path class="st1" d="M131,71.2l-24.4-25l46.4-6.5L131,71.2z"/>
            </g>
            <g id="triangle6">
                <path class="st2" d="M131,71.2L111.1,90l-4.5-43.8L131,71.2z"/>
            </g>
            <g id="triangle5">
                <path class="st0" d="M109.6,76.1l-2.2-21.5l0.3,21.4L109.6,76.1z"/>
            </g>
            <g id="triangle4">
                <path class="st1" d="M106.6,46.2l0.8,8.3l0.3,21.4l-23.2-1.5L106.6,46.2z"/>
            </g>
            <g id="triangle3">
                <path class="st3" d="M84.5,74.5L59.6,51l47-4.7L84.5,74.5z"/>
            </g>
            <g id="triangle2">
                <polygon class="st0" points="50.5,52 37.9,30.5 69.7,60.4"/>
            </g>
            <g id="triangle1">
                <path class="st2" d="M50.5,52l-12,18.3L59.6,56L50.5,52z"/>
            </g>
        </svg>
      </div>
    </template>

    <template v-if="!loadingState">
    <div class="content-headline">
      <div class="content-headline__wrapper">
        <h1>{{locale.compute.computes}}</h1>
        <div class="content-headline__control-buttons">
          <router-link to="/app/computes/new">
            <button class="button">{{locale.compute.buttonNew}}</button>
          </router-link>
          <div class="help" v-on:click="openModal({ id: 'modalHelp' })">
            Hilfe anzeigen
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="responsive">
        <thead>
        <tr>
          <th scope="col">{{locale.compute.name}}</th>
          <th scope="col">{{locale.compute.ips}}</th>
          <th scope="col">{{locale.compute.status}}</th>
          <th scope="col">{{locale.compute.flavor}}</th>
          <th scope="col">{{locale.compute.actions}}</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="compute in computes">
          <tr :key="compute.id">
            <td data-label="Name">{{compute.name}}</td>
            <td data-label="IPs">
              <template v-for="network in compute.addresses">
                <template v-for="net in network">
                  {{net.addr}}<br :key="net.addr"/>
                </template>
              </template>
            </td>
            <td data-label="Status">{{compute.status}}
              <template v-if="compute.status == 'BUILD' || compute.status == 'RESIZE' || compute.status == 'REVERT_RESIZE'">
                <div class="spinner spinner--compute-build">
                  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 200 117" style="enable-background:new 0 0 200 117;" xml:space="preserve">
                    <g id="triangle8">
                        <path class="st0" d="M153,60.4l-22,10.9l22-31.4V60.4z"/>
                    </g>
                    <g id="triangle7">
                        <path class="st1" d="M131,71.2l-24.4-25l46.4-6.5L131,71.2z"/>
                    </g>
                    <g id="triangle6">
                        <path class="st2" d="M131,71.2L111.1,90l-4.5-43.8L131,71.2z"/>
                    </g>
                    <g id="triangle5">
                        <path class="st0" d="M109.6,76.1l-2.2-21.5l0.3,21.4L109.6,76.1z"/>
                    </g>
                    <g id="triangle4">
                        <path class="st1" d="M106.6,46.2l0.8,8.3l0.3,21.4l-23.2-1.5L106.6,46.2z"/>
                    </g>
                    <g id="triangle3">
                        <path class="st3" d="M84.5,74.5L59.6,51l47-4.7L84.5,74.5z"/>
                    </g>
                    <g id="triangle2">
                        <polygon class="st0" points="50.5,52 37.9,30.5 69.7,60.4"/>
                    </g>
                    <g id="triangle1">
                        <path class="st2" d="M50.5,52l-12,18.3L59.6,56L50.5,52z"/>
                    </g>
                </svg>
                </div>
              </template>

              <template v-if="loadingState && compute.id == form.id">
                <div class="spinner spinner--compute-build">
                  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 200 117" style="enable-background:new 0 0 200 117;" xml:space="preserve">
                    <g id="triangle8">
                        <path class="st0" d="M153,60.4l-22,10.9l22-31.4V60.4z"/>
                    </g>
                    <g id="triangle7">
                        <path class="st1" d="M131,71.2l-24.4-25l46.4-6.5L131,71.2z"/>
                    </g>
                    <g id="triangle6">
                        <path class="st2" d="M131,71.2L111.1,90l-4.5-43.8L131,71.2z"/>
                    </g>
                    <g id="triangle5">
                        <path class="st0" d="M109.6,76.1l-2.2-21.5l0.3,21.4L109.6,76.1z"/>
                    </g>
                    <g id="triangle4">
                        <path class="st1" d="M106.6,46.2l0.8,8.3l0.3,21.4l-23.2-1.5L106.6,46.2z"/>
                    </g>
                    <g id="triangle3">
                        <path class="st3" d="M84.5,74.5L59.6,51l47-4.7L84.5,74.5z"/>
                    </g>
                    <g id="triangle2">
                        <polygon class="st0" points="50.5,52 37.9,30.5 69.7,60.4"/>
                    </g>
                    <g id="triangle1">
                        <path class="st2" d="M50.5,52l-12,18.3L59.6,56L50.5,52z"/>
                    </g>
                </svg>
                </div>
              </template>
            </td>
            <td data-label="Flavor">{{getFlavorNameById(compute.flavor).name }}</td>
            <td data-label="Action">
              <template v-if="compute.status == 'ACTIVE'">
                <a href="#" v-on:click="shutdownCompute(compute.id) + setIdForLoading(compute.id)" class="action-tooltip">
                  <span class="actions-icon actions-icon--power-off"></span>
                  <div class="tooltip">
                    <span class="tooltiptext">{{locale.compute.shutdown}}</span>
                  </div>
                </a>
              </template>
              <template v-if="compute.status == 'SHUTOFF'">
                <a href="#" v-on:click="startCompute(compute.id) + setIdForLoading(compute.id)">
                  <span class="actions-icon actions-icon--play"></span>
                  <div class="tooltip">
                    <span class="tooltiptext">{{locale.compute.start}}</span>
                  </div>
                </a>
              </template>
              <template v-if="compute.status == 'ACTIVE' || compute.status == 'SHUTOFF'">
                <a href="#" v-on:click="createSnapshot(compute.id)" class="action-tooltip">
                  <span class="actions-icon actions-icon--camera"></span>
                  <div class="tooltip">
                    <span class="tooltiptext">{{locale.compute.snapshot_create}}</span>
                  </div>
                </a>
                <a href="#" v-on:click="openModal({ id: 'modalGlobal', data: compute}) + setIdForLoading(compute.id)" class="action-tooltip">
                  <span class="actions-icon actions-icon--globe"></span>
                  <div class="tooltip">
                    <span class="tooltiptext">{{locale.compute.tooltipAssign}}</span>
                  </div>
                </a>
                <a href="#"
                   v-on:click="openModal({ id: 'modalSecurityGroup', data: compute}) + modalSecurityGroup(compute.id)"
                   class="action-tooltip">
                  <span class="actions-icon actions-icon--fire"></span>
                  <div class="tooltip">
                    <span class="tooltiptext">{{locale.compute.tooltipSecurityGroup}}</span>
                  </div>
                </a>
                <a href="#" v-on:click="openModal({ id: 'modalResizeFlavor', data: compute}) + modalResizeFlavor(compute.flavor)" class="action-tooltip">
                  <span class="actions-icon actions-icon--resize"></span>
                  <div class="tooltip">
                    <span class="tooltiptext">{{locale.compute.tooltipResizeFlavor}}</span>
                  </div>
                </a>
                <a href="#" v-on:click="openModal({ id: 'modalDelete', data: compute})" class="action-tooltip">
                  <span class="actions-icon actions-icon--trash"></span>
                  <div class="tooltip">
                    <span class="tooltiptext">{{locale.compute.tooltipDelete}}</span>
                  </div>
                </a>
              </template>
              <template v-if="compute.status == 'VERIFY_RESIZE'">
                <a href="#" v-on:click="openModal({ id: 'modalConfirmResize', data: compute})" class="action-tooltip">
                  <span class="actions-icon actions-icon--confirm-resize"></span>
                  <div class="tooltip">
                    <span class="tooltiptext">{{locale.compute.tooltipConfirmResize}}</span>
                  </div>
                </a>
              </template>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>

    <ModalBox id="modalGlobal">
      <template slot="header">
        {{locale.compute.assignText}} {{modalData.name}}:
      </template>
      <template slot="body">
        <div class="select-wrapper">
          <select class="select" v-model="selectedIp">
            <option value=""></option>
            <template v-if="modalData.floatingIP">
              <option value="delete">{{locale.compute.detachIP}}</option>
            </template>
            <template v-for="float in floating">
              <option v-bind:key="float.id" :value="float.id" v-if="float.status == 'DOWN'">{{ float.floatingIpAddress
                }}
              </option>
            </template>
          </select>
        </div>
        <div class="modal-buttons">
          <a href="#" class="button button--secondary" v-on:click="closeModal({id: 'modalGlobal'})">{{locale.compute.cancel}}</a>
          <a href="#" class="button"
             v-on:click="assignFloatingToServer(selectedIp, modalData.id) + closeModal({id: 'modalGlobal'})"
             data-dismiss="modal">{{locale.compute.assign}}</a>
        </div>
      </template>
    </ModalBox>

    <ModalBox id="modalHelp">
      <template slot="header">
        <h3>Überschrift</h3>
      </template>
      <template slot="body">
        <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
          dolore magna aliquyam erat,
          sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea
          takimata sanctus est Lorem ipsum dolor sit amet.
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
          dolore magna aliquyam erat, sed diam voluptua.
          At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus
          est Lorem ipsum dolor sit amet.</p>
      </template>
    </ModalBox>

    <ModalBox id="modalDelete">
      <template slot="header">
        {{locale.compute.deleteText}} <span>{{modalData.name}}</span>?
      </template>
      <template slot="body">
        <div class="modal-buttons">
          <a href="#" class="button button--secondary" v-on:click="closeModal({id: 'modalDelete'})">{{locale.compute.cancel}}</a>
          <a href="#" class="button button--danger"
             v-on:click="deleteCompute(modalData.id) + setIdForLoading(modalData.id) + closeModal({id: 'modalDelete'})">{{locale.compute.delete}}</a>
        </div>
      </template>
    </ModalBox>

    <ModalBox id="modalSecurityGroup">
      <template slot="header">
        {{locale.compute.modal.newSecurityGroup.title}} <span>{{modalData.name}}</span>
      </template>
      <template slot="body">
        <form class="form" @submit.prevent="submitModalSecurity">
          <input type="hidden" v-model="form.id">
        <template v-for="securitygroup in securitygroups" v-if="securitygroups">
          <div class="checkbox" :key="securitygroup.id">
            <input type="checkbox" v-model="form.activeSecurityGroups" v-bind:value="securitygroup.id" v-bind:id="securitygroup.id">
            <label v-bind:for="securitygroup.id">{{securitygroup.name}}</label>
          </div>
        </template>
          <div class="modal-buttons">
            <button class="button" v-on:click="closeModal({id: 'modalSecurityGroup'})">
              {{locale.compute.modal.newSecurityGroup.button}}
            </button>
          </div>
        </form>
        <template v-if="securitygroups.length == 0">
          <div>
            <p>
              {{locale.compute.noSecurityGroups}}
            </p>
          </div>
        </template>
      </template>
    </ModalBox>

    <ModalBox id="modalResizeFlavor">
      <template slot="header">
        {{locale.compute.modal.resizeFlavor.title}}
      </template>
      <template slot="body">
        <div class="select-wrapper">
          <select class="select" v-model="form.flavor" data-vv-name="form.flavor">
            <template v-for="flavor in flavors">
              <option v-bind:key="flavor.id"  :value="flavor.id">{{flavor.name}}</option>
            </template>
          </select>
        </div>
        <div class="modal-buttons">
          <a href="#" class="button button--secondary" v-on:click="closeModal({id: 'modalResizeFlavor'})">{{locale.compute.modal.resizeFlavor.cancel}}</a>
          <a href="#" class="button" v-on:click="ResizeFlavor(form.flavor, modalData.id) + closeModal({id: 'modalResizeFlavor'})" data-dismiss="modal">{{locale.compute.modal.resizeFlavor.button}}</a>
        </div>
      </template>
    </ModalBox>

<ModalBox id="modalConfirmResize">
  <template slot="header">
    {{locale.compute.modal.confirmResize.title}}
  </template>
  <template slot="body">
    <div class="modal-buttons">
      <a href="#" class="button button--secondary" v-on:click="resetResize(modalData.id) + closeModal({id: 'modalConfirmResize'})">{{locale.compute.modal.confirmResize.cancel}}</a>
      <a href="#" class="button button--danger"
         v-on:click="confirmResize(modalData.id) + setIdForLoading(modalData.id) + closeModal({id: 'modalConfirmResize'})">{{locale.compute.modal.confirmResize.button}}</a>
    </div>
  </template>
</ModalBox>
    </template>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import ModalBox from '../utils/modalBox.vue'

export default {
  name: 'Compute',
  components: {ModalBox},
  computed: {
    ...mapGetters({
      getFlavorNameById: 'flavors/getFlavorNameById'
    }),
    ...mapState(['locale']),
    ...mapState({
      floating: state => state.floating.floating,
      computes: state => state.computes.computes,
      flavors: state => state.flavors.flavors,
      computeSgroup: state => state.computes.computeSgroup,
      securitygroups: state => state.securitygroups.securitygroups,
      loadingState: state => state.loadingState,
      modalData: state => state.modal.modalData
    })
  },
  data: function () {
    return {
      interval: null,
      selectedIp: '',
      form: {
        'activeSecurityGroups': [],
        'flavor': '',
        'id': ''
      }
    }
  },
  methods: {
    ...mapActions({
      'shutdownCompute': 'computes/shutdownCompute',
      'startCompute': 'computes/startCompute',
      'deleteCompute': 'computes/deleteCompute',
      'openModal': 'modal/openModal',
      'closeModal': 'modal/closeModal'
    }),
    ...mapActions({'createSnapshot': 'snapshots/createSnapshot'}),
    assignFloatingToServer: function (FloatingId, ComputeId) {
      this.$store.dispatch('floating/assignFloatingToServer', {
        'FloatingId': FloatingId,
        'ComputeId': ComputeId
      }).then((response) => {
        this.$store.dispatch('computes/getComputes', 0)
        this.form = []
      }).catch((error) => {
        console.log(error)
      })
    },
    refresh: function () {
      this.interval = setInterval(function () {
        this.$store.dispatch('computes/getComputes', 0)
        this.$store.dispatch('securitygroups/getSecurityGroups', 0)
        this.$store.dispatch('floating/getFloating', 0)
      }.bind(this), 1000)
    },
    modalSecurityGroup: function (id) {
      this.form.id = id
      this.form.activeSecurityGroups = []
      this.$store.dispatch('computes/getAttachedSecurityGroups', id).then(() => {
        Object.keys(this.computeSgroup).forEach(itemKey => {
          this.form.activeSecurityGroups.push(itemKey)
        })
      })
    },
    submitModalSecurity () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('computes/setSecurityGroupsToCompute', {'id': this.form.id, 'form': this.form.activeSecurityGroups}).then(() => {
          })
          this.form.id = ''
        }
      })
    },
    modalResizeFlavor: function (id) {
      this.form.flavor = id
    },
    setIdForLoading: function (id) {
      this.form.id = id
    },
    ResizeFlavor: function (Flavor, ComputeId) {
      this.$store.dispatch('computes/resize', {
        'id': ComputeId,
        'flavor': Flavor
      }).then(() => {
      })
    },
    confirmResize: function (id) {
      this.$store.dispatch('computes/confirmResize', {
        'id': id
      }).then(() => {
      })
    },
    resetResize: function (id) {
      this.$store.dispatch('computes/resetResize', {
        'id': id
      }).then(() => {
      })
    }
  },
  created () {
    this.$store.dispatch('computes/getComputes', 1)
    this.refresh()
  },
  beforeDestroy: function () {
    clearInterval(this.interval)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Compute.vue